import React, { useCallback } from "react";
import { Linking } from "react-native";
import useIsRunningInBallpark from "./useIsRunningInBallpark";

function useSendSMS() {
  const { isRunningInBallpark } = useIsRunningInBallpark();
  const sendSMS = useCallback(
    (message: string) => {
      if (isRunningInBallpark) {
        window.location.href = `sms:?&body=${encodeURI(message)}`;
      } else {
        Linking.openURL(`sms:?&body=${encodeURI(message)}`);
      }
    },
    [isRunningInBallpark]
  );

  return sendSMS;
}

export default useSendSMS;
